import { render, staticRenderFns } from "./descView.vue?vue&type=template&id=6af39ec8"
import script from "./descView.vue?vue&type=script&lang=js"
export * from "./descView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports